var map = {
	"./atoms/alert/alert-types.twig": 33014,
	"./atoms/alert/alert-unclosable.twig": 95381,
	"./atoms/button/button-secondary-states.twig": 71462,
	"./atoms/button/button-secondary.twig": 16343,
	"./atoms/button/button-sizes.twig": 56403,
	"./atoms/button/button-states.twig": 7911,
	"./atoms/button/button-tertiary-states.twig": 64566,
	"./atoms/button/button-tertiary.twig": 34055,
	"./atoms/checkbox/checkbox-inline.twig": 7826,
	"./atoms/checkbox/checkbox-states.twig": 49177,
	"./atoms/collapse/collapse-header.twig": 47638,
	"./atoms/collapse/collapse-partial.twig": 67886,
	"./atoms/collapse/collapse-title.twig": 90137,
	"./atoms/definition-list/definition-list-grid.twig": 54687,
	"./atoms/definition-list/definition-list.twig": 78674,
	"./atoms/icon/icon-list-feather.twig": 91713,
	"./atoms/icon/icon-list.twig": 77695,
	"./atoms/input/input-disabled.twig": 91451,
	"./atoms/input/input-error.twig": 22065,
	"./atoms/input/input-focus.twig": 72311,
	"./atoms/input/input-hover.twig": 85505,
	"./atoms/input/input-value.twig": 88926,
	"./atoms/link/link-bg-variants.twig": 43453,
	"./atoms/link/link-button.twig": 88009,
	"./atoms/link/link-icon.twig": 30000,
	"./atoms/link/link-login.twig": 59068,
	"./atoms/list/list-inline.twig": 57340,
	"./atoms/list/list-ordered.twig": 74680,
	"./atoms/list/list-unordered.twig": 481,
	"./atoms/list/list-unstyled.twig": 63461,
	"./atoms/nav-lang/nav-lang-short.twig": 45699,
	"./atoms/nav-lang/nav-lang.twig": 88180,
	"./atoms/nav-toggle-mobile/nav-toggle-mobile.twig": 12522,
	"./atoms/nav-toggle/nav-toggle-async.twig": 10233,
	"./atoms/nav-toggle/nav-toggle.twig": 96284,
	"./atoms/nav-user/nav-user-login.twig": 50322,
	"./atoms/nav-user/nav-user.twig": 93766,
	"./atoms/picture/picture-avatar.twig": 20254,
	"./atoms/picture/picture-cover.twig": 18608,
	"./atoms/picture/picture-fullwidth-teaser.twig": 93425,
	"./atoms/picture/picture-news-thumb.twig": 693,
	"./atoms/picture/picture-one-third-square.twig": 35011,
	"./atoms/picture/picture-one-third.twig": 77831,
	"./atoms/picture/picture-portrait.twig": 93272,
	"./atoms/picture/picture-question.twig": 73043,
	"./atoms/picture/picture-thumb-square.twig": 2071,
	"./atoms/radio/radio-inline.twig": 39690,
	"./atoms/radio/radio-list.twig": 32439,
	"./atoms/research-icon/research-icon-discrete-link.twig": 92405,
	"./atoms/research-icon/research-icon-group.twig": 18984,
	"./atoms/research-icon/research-icon-link-group.twig": 80309,
	"./atoms/research-icon/research-icon-link.twig": 23943,
	"./atoms/research-icon/research-icon-negative-link.twig": 9073,
	"./atoms/research-icon/research-icon-negative.twig": 82072,
	"./atoms/research-icon/research-icon-round-discrete-link.twig": 28812,
	"./atoms/research-icon/research-icon-round-link.twig": 23500,
	"./atoms/research-icon/research-icon-round.twig": 76839,
	"./atoms/research-icon/research-icon-single-link-with-details.twig": 31810,
	"./atoms/research-icon/research-icon-single-link.twig": 8892,
	"./atoms/research-icon/research-icon-single.twig": 18295,
	"./atoms/research-icon/research-icon.twig": 79210,
	"./atoms/select/select-multiple.twig": 90677,
	"./atoms/social-icon/social-icon-discrete-link.twig": 60289,
	"./atoms/social-icon/social-icon-group.twig": 87988,
	"./atoms/social-icon/social-icon-link-group.twig": 84929,
	"./atoms/social-icon/social-icon-link.twig": 53203,
	"./atoms/social-icon/social-icon-negative-link.twig": 9453,
	"./atoms/social-icon/social-icon-negative.twig": 46820,
	"./atoms/social-icon/social-icon-round-discrete-link.twig": 48768,
	"./atoms/social-icon/social-icon-round-link.twig": 89600,
	"./atoms/social-icon/social-icon-round.twig": 51355,
	"./atoms/social-icon/social-icon-single-link-with-details.twig": 78150,
	"./atoms/social-icon/social-icon-single-link.twig": 77400,
	"./atoms/social-icon/social-icon-single.twig": 7731,
	"./atoms/social-icon/social-icon.twig": 20006,
	"./atoms/switch/switch-inline.twig": 62960,
	"./atoms/switch/switch-states.twig": 61719,
	"./atoms/tag/tag-input.twig": 37243,
	"./atoms/trapeze/trapeze-horizontal.twig": 73863,
	"./atoms/trapeze/trapeze-pseudo.twig": 50773,
	"./content-types/bachelor-project/bachelor-project.twig": 69191,
	"./content-types/basic-page/basic-page-highlighted.twig": 33939,
	"./content-types/basic-page/basic-page.twig": 36479,
	"./content-types/coursebook/coursebook-legend.twig": 73797,
	"./content-types/coursebook/coursebook-program.twig": 51650,
	"./content-types/event/event-highlight-listing.twig": 6965,
	"./content-types/event/event-highlight.twig": 25148,
	"./content-types/event/event-invitation.twig": 17717,
	"./content-types/event/event-just-finished.twig": 20403,
	"./content-types/event/event-listing-featured.twig": 41659,
	"./content-types/event/event-listing.twig": 36208,
	"./content-types/event/event-wrapper.twig": 98559,
	"./content-types/graph-search/graph-search.twig": 45677,
	"./content-types/news/news-basic-teaser.twig": 47243,
	"./content-types/news/news-distinction.twig": 43938,
	"./content-types/news/news-highlighted-carousel.twig": 35888,
	"./content-types/news/news-highlighted.twig": 75497,
	"./content-types/news/news-horizontal-listing-gray.twig": 76,
	"./content-types/news/news-horizontal-listing.twig": 16327,
	"./content-types/news/news-latest-two.twig": 79094,
	"./content-types/news/news-press-release.twig": 20923,
	"./content-types/press-review/press-review.twig": 94435,
	"./content-types/project-list/project-list.twig": 66139,
	"./content-types/research-field/research-field.twig": 95655,
	"./content-types/research-project/research-project.twig": 31309,
	"./content-types/science-question/science-question.twig": 52301,
	"./content-types/study-plan/study-plan-bachelor.twig": 4000,
	"./content-types/study-plan/study-plan-master.twig": 87240,
	"./content-types/study-plan/study-plan-mineur.twig": 79434,
	"./content-types/study-plan/study-plan.twig": 20153,
	"./molecules/access-nav/access-nav.twig": 80239,
	"./molecules/avatar-teaser/avatar-teaser-multiple.twig": 70974,
	"./molecules/avatar-teaser/avatar-teaser.twig": 3845,
	"./molecules/breadcrumb/breadcrumb-dropdown.twig": 61935,
	"./molecules/breadcrumb/breadcrumb-tagged.twig": 16762,
	"./molecules/card-deck/card-deck-duo-gray.twig": 12266,
	"./molecules/card-deck/card-deck-duo.twig": 37260,
	"./molecules/card-deck/card-deck-link-duo-gray.twig": 49171,
	"./molecules/card-deck/card-deck-link-duo.twig": 85283,
	"./molecules/card-deck/card-deck-link-single-gray.twig": 90807,
	"./molecules/card-deck/card-deck-link-single.twig": 92015,
	"./molecules/card-deck/card-deck-mini-cards.twig": 50067,
	"./molecules/card-deck/card-deck-single-gray.twig": 96448,
	"./molecules/card-deck/card-deck-single.twig": 86694,
	"./molecules/card-deck/card-deck.twig": 18849,
	"./molecules/card/card-inside-links.twig": 4828,
	"./molecules/card/card-link.twig": 39772,
	"./molecules/carousel/carousel-base.twig": 4185,
	"./molecules/collapse-group/collapse-group-people-contacts.twig": 13619,
	"./molecules/collapse-group/collapse-group-rich-content.twig": 70440,
	"./molecules/collapse-group/collapse-group.twig": 36573,
	"./molecules/datepicker/datepicker-fancy.twig": 16391,
	"./molecules/filters/filters-blog.twig": 88066,
	"./molecules/form-group/form-group-checkboxes.twig": 27089,
	"./molecules/form-group/form-group-error.twig": 14784,
	"./molecules/form-group/form-group-radio.twig": 329,
	"./molecules/form-group/form-group-search.twig": 30360,
	"./molecules/form-group/form-group-select.twig": 56060,
	"./molecules/form-group/form-group-textarea.twig": 214,
	"./molecules/form-group/form-group-upload.twig": 45649,
	"./molecules/form-group/form-group-valid.twig": 91264,
	"./molecules/form-group/form-group.twig": 76403,
	"./molecules/key-number/key-number-hn-link.twig": 77533,
	"./molecules/key-number/key-number-hn.twig": 65364,
	"./molecules/key-number/key-number-large.twig": 96223,
	"./molecules/key-number/key-number.twig": 59977,
	"./molecules/links-group/links-group-teaser.twig": 98086,
	"./molecules/links-group/links-group.twig": 2077,
	"./molecules/list-group/list-group-borderless.twig": 81295,
	"./molecules/list-group/list-group-event.twig": 73518,
	"./molecules/list-group/list-group-infoscience.twig": 79080,
	"./molecules/list-group/list-group-teasers.twig": 84491,
	"./molecules/list-group/list-group.twig": 42135,
	"./molecules/pagination/pagination-center.twig": 96401,
	"./molecules/pagination/pagination-load-more.twig": 72460,
	"./molecules/search/search-mobile.twig": 738,
	"./molecules/social-feed/social-feed-facebook.twig": 94810,
	"./molecules/social-feed/social-feed-instagram.twig": 17148,
	"./molecules/social-feed/social-feed.twig": 3905,
	"./molecules/social/social-follow.twig": 3603,
	"./molecules/sponsor/sponsor-link.twig": 74874,
	"./molecules/table-of-contents/table-of-contents-inline.twig": 19271,
	"./molecules/table-of-contents/table-of-contents-multi-level.twig": 98034,
	"./molecules/table-of-contents/table-of-contents.twig": 245,
	"./molecules/tables/tables-boxed-sortable.twig": 42845,
	"./molecules/tables/tables-boxed.twig": 89872,
	"./molecules/tables/tables-sortable.twig": 43118,
	"./molecules/tabs/tabs-light.twig": 15730,
	"./molecules/tabs/tabs-vertical.twig": 47966,
	"./organisms/card-slider/card-slider.twig": 81825,
	"./organisms/contact/contact-banner.twig": 30848,
	"./organisms/contact/contact-columns.twig": 89739,
	"./organisms/contact/contact-compact-for-columns.twig": 91497,
	"./organisms/contact/contact-compact.twig": 52741,
	"./organisms/contact/contact-list.twig": 83578,
	"./organisms/cookie-consent/cookie-consent.twig": 2597,
	"./organisms/footer/footer-buttons.twig": 19629,
	"./organisms/footer/footer-col.twig": 93742,
	"./organisms/footer/footer-dark.twig": 48718,
	"./organisms/footer/footer-de.twig": 21893,
	"./organisms/footer/footer-en.twig": 51417,
	"./organisms/footer/footer-faculties.twig": 51340,
	"./organisms/footer/footer-legal.twig": 40813,
	"./organisms/footer/footer-light-dark.twig": 43201,
	"./organisms/footer/footer-light-de.twig": 76502,
	"./organisms/footer/footer-light-en.twig": 25486,
	"./organisms/footer/footer-light.twig": 35436,
	"./organisms/footer/footer-socials.twig": 34060,
	"./organisms/fullwidth-teaser/fullwidth-teaser-horizontal.twig": 972,
	"./organisms/fullwidth-teaser/fullwidth-teaser-left.twig": 36369,
	"./organisms/fullwidth-teaser/fullwidth-teaser-legend.twig": 20885,
	"./organisms/fullwidth-teaser/fullwidth-teaser.twig": 55727,
	"./organisms/header/header-de.twig": 15561,
	"./organisms/header/header-en.twig": 39053,
	"./organisms/header/header-fr.twig": 66190,
	"./organisms/header/header-light-drawer.twig": 97440,
	"./organisms/header/header-light-submenu.twig": 11144,
	"./organisms/header/header-light.twig": 89072,
	"./organisms/headlines/headlines-legend.twig": 33511,
	"./organisms/hero/hero-legend.twig": 873,
	"./organisms/introduction/introduction-gray.twig": 26615,
	"./organisms/key-number-group/key-number-group-hn.twig": 91408,
	"./organisms/key-number-group/key-number-group.twig": 84125,
	"./organisms/nav-aside/nav-aside.twig": 94749,
	"./organisms/nav-main/nav-main.twig": 66853,
	"./organisms/nav-mobile/nav-mobile.twig": 13331,
	"./organisms/newsletter-sign-up/newsletter-sign-up.twig": 1493,
	"./organisms/social-feed-group/social-feed-group.twig": 28453,
	"./organisms/sponsor-list/sponsor-list-link.twig": 48062,
	"./organisms/sponsor-list/sponsor-list.twig": 44301,
	"./pages/association-homepage/association-homepage.twig": 18866,
	"./pages/association-list/association-list.twig": 18110,
	"./pages/basic-page/basic-page.twig": 20330,
	"./pages/blog-homepage/blog-homepage.twig": 91776,
	"./pages/blog-single/blog-single.twig": 59800,
	"./pages/error-404/error-404.twig": 50232,
	"./pages/event-detail/event-detail.twig": 97330,
	"./pages/event-homepage/event-homepage.twig": 91320,
	"./pages/event-list/event-list.twig": 53232,
	"./pages/lab-homepage/lab-homepage.twig": 70182,
	"./pages/layout-demo/layout-demo.twig": 23160,
	"./pages/news-detail/news-detail.twig": 13304,
	"./pages/news-homepage/news-homepage.twig": 98828,
	"./pages/people-detail/people-detail.twig": 37872,
	"./pages/people-list/people-list.twig": 34056,
	"./pages/press-review/press-review.twig": 51582,
	"./pages/study-plan-course/study-plan-course.twig": 43928,
	"./pages/study-plan/study-plan.twig": 48432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54857;